import React from "react";
import "./styles.scss";
import "./mobile.scss";
import { ButtonIcon, FormHeader, Tag } from "..";
import { getLanguage } from "../../utils/environment";
import moment from "moment";
import { motion } from "motion/react";

const lan = getLanguage();

const Index = ({ data, onChange, onClick, isBorder, item }) => {
  let inputElement = null;

  inputElement = (
    <>
      <motion.div
        whileHover={{ x: 1 }}
        whileTap={{ scale: 0.95 }}
        transition={{ type: "spring", stiffness: 300 }}
      >
        <div
          className={`d-flex flex-row justify-content-between`}
          onClick={onClick}
        >
          {/* {data.isTrendingNo && (
            <>
              <div className={"tncmw__trending-no"}>{data.trendingNo}</div>
            </>
          )} */}
          {data.created_at && data.isDate && (
            <>
              <div className={"tncmw__news-date"}>
                <span className={"tncmw__nd-day"}>
                  {moment(data.created_at).format("DD")}
                </span>
                <span className={"tncmw__nd-month"}>
                  {moment(data.created_at).format("MMM")}
                </span>
              </div>
            </>
          )}
          <>
            {data.img_url && (
              <img
                src={data?.img_url}
                alt={data?.header}
                className={"tncmw__img"}
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
            )}
          </>
          {/* <img src={data?.img_url} alt="news-img" className={"tncmw__img"} /> */}
          <div style={{ width: "100%" }}>
            <div
              className={
                "d-flex flex-row justify-content-between align-items-center"
              }
            >
              <div className={"d-flex flex-column"}>
                <FormHeader
                  onClick={onClick}
                  data={{
                    lan: lan,
                    formHeader: data.header,
                    size: "md-lg title",
                  }}
                />

                <div className="d-flex flex-row align-items-center tncmw_view_box">
                  <div className={"tncmw__date"}>
                    {moment(data.created_at).format("MMMM Do YYYY")}
                  </div>
                  <div className="d-flex p-2">
                    <Tag
                      data={{
                        isIcon: true,
                        tagIcon: "eye",
                        tagName: data?.tagViews,
                        type: "views_tag_sm",
                      }}
                    />
                  </div>
                </div>
              </div>
              {data.isTrendingNo && (
                <>
                  <div className={"tncmw__trending-no"}>{data.trendingNo}</div>
                </>
              )}
              {/* <img
                src={data?.img_url}
                alt="news-img"
                className={"tncmw__img"}
              /> */}
              {/* {data?.isArrow && ( */}
              {/* <motion.div
                className="tncmw__action"
                whileHover={{ scale: 1.2, rotate: 5 }}
                whileTap={{ scale: 0.95 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <ButtonIcon
                  data={{
                    iconName: "h-wrrow-right",
                    size: "xl",
                    type: "light",
                  }}
                />
              </motion.div> */}
              {/* )} */}
            </div>
            {data.isBorder && (
              <>
                <div className={"tncmw__border"}></div>
              </>
            )}
          </div>
        </div>
      </motion.div>
    </>
  );

  return (
    <>
      <div
        className={`trending-news-card-main-wrapper ${data.type}  ${data.mainLayerStyles}`}
      >
        <>{inputElement}</>
      </div>
    </>
  );
};

export default Index;
